import { useEffect } from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'

export function useGATracker(trackingCode, whitelistedHostnames = []) {
  const noGA = whitelistedHostnames.length > 0 && whitelistedHostnames.every(hostname => !hostname.includes(location.hostname.toLowerCase()))
  useEffect(() => {
    if (noGA) return
    ReactGA.initialize(trackingCode)
  }, [noGA, trackingCode])
  const routerLocation = useLocation()
  useEffect(() => {
    if (noGA) return
    const page = routerLocation.pathname
    ReactGA.set({ page })
    ReactGA.pageview(page)
  }, [noGA, routerLocation.pathname])
}
